import MarkdownRenderer from "@/components/markdownRenderer/MarkdownRenderer";

import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "../../@/components/ui/dialog";
import { Button } from "../../@/components/ui/button";
import { ClipLoader } from "react-spinners";
import { Spinner } from "@/components/spinner";

export default function AiGeneratedReviewDialog({
  open,
  onOpenChange,
  loading,
  deleting,
  hasAIReview,
  aiReviewText,
  canReject,
  onReject,
  onApproveUse,
  approveLabel = "Approve/Use",
}) {
  const rejectEnabled =
    typeof canReject === "boolean" ? canReject : Boolean(hasAIReview);

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="">
        <DialogHeader className="">
          <DialogTitle className="font-heading text-xl text-(--neutral-900)">
            AI-generated Review
          </DialogTitle>
          <div className="text-sm text-(--neutral-600) font-body">
            Below is a preliminary submission review by Rukia AI
          </div>
        </DialogHeader>

        <div className="">
          <div className="">
            {loading ? (
              <div className="text-normal text-(--neutral-700) font-body">
                <Spinner />
              </div>
            ) : !hasAIReview ? (
              <div className="text-normal text-(--neutral-700) font-body">
                No AI review available for this submission.
              </div>
            ) : (
              <div className="text-(--neutral-800)">
                <MarkdownRenderer content={aiReviewText} small />
              </div>
            )}
          </div>
        </div>

        <DialogFooter className="flex-row justify-between">
          <Button
            type="button"
            variant="outline"
            disabled={loading || deleting}
            onClick={() => onOpenChange?.(false)}
          >
            Cancel
          </Button>

          <div className="flex items-center gap-2">
            {typeof onReject === "function" ? (
              <Button
                type="button"
                variant="destructive"
                disabled={loading || deleting || !rejectEnabled}
                onClick={onReject}
              >
                {deleting ? <ClipLoader size={24} color="#fff" /> : "Reject"}
              </Button>
            ) : null}

            {typeof onApproveUse === "function" ? (
              <Button
                type="button"
                disabled={loading || deleting || !hasAIReview}
                onClick={onApproveUse}
                className="bg-(--color-success) border-(--color-success)"
              >
                {approveLabel}
              </Button>
            ) : null}
          </div>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
